import React, { useCallback, useState } from 'react';
import { V3OfferProvider } from '../contexts/V3OfferContext';
import V3FinancePage from '../components/V3FinancePage';
import V3FinancePageMobile from '../components/V3FinancePageMobile';
import V3NewOfferFTUXModal from '../components/V3NewOfferFTUXModal';
import useIsMobile from '../../shared/hooks/useIsMobile';

const shouldOpenFtux = (offer) => (
  offer && offer.ftux_dismissed === false && !offer.template_id
);

const V3OfferEditApp = (props) => {
  const [ftuxOpen, setFtuxOpen] = useState(() => shouldOpenFtux(props.offer));
  // Which act the modal was opened FOR. Selecting a sibling in the Lineup panel
  // switches acts client-side without navigating, so props.offer stays the one
  // the URL points at — and the modal would decide primary-vs-support from the
  // wrong offer, showing event templates to a support.
  const [ftuxOffer, setFtuxOffer] = useState(props.offer);
  // Which pane to land on, when the caller means a specific one — the template
  // bar's "Browse blueprints" is a solo show's only route back to the blueprint
  // library once this modal has been dismissed.
  const [ftuxNav, setFtuxNav] = useState(null);
  const openFtuxModal = useCallback((offer, options = {}) => {
    setFtuxOffer(offer || props.offer);
    setFtuxNav(options.nav || null);
    setFtuxOpen(true);
  }, [props.offer]);
  const closeFtuxModal = useCallback(() => setFtuxOpen(false), []);
  const isMobile = useIsMobile();

  return (
    <V3OfferProvider
      csrfToken={props.csrfToken}
      team={props.team}
      currentUser={props.currentUser}
      initialOffer={props.offer}
      initialBudget={props.budget}
      initialLineItems={props.lineItems}
      eventOffers={props.eventOffers}
      confirm={props.confirm}
      entryOrigin={props.entryOrigin}
      editorVariant="v3"
      openFtuxModal={openFtuxModal}
    >
      {isMobile ? <V3FinancePageMobile /> : <V3FinancePage />}
      <V3NewOfferFTUXModal
        open={ftuxOpen}
        onClose={closeFtuxModal}
        team={props.team}
        offer={ftuxOffer || props.offer}
        csrfToken={props.csrfToken}
        initialNav={ftuxNav}
      />
    </V3OfferProvider>
  );
};

export default V3OfferEditApp;
